import { render } from "./DatasetSegmentsSurveyDetails.vue?vue&type=template&id=45ec533a"
import script from "./DatasetSegmentsSurveyDetails.vue?vue&type=script&lang=js"
export * from "./DatasetSegmentsSurveyDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__